/* eslint react/no-multi-comp: 0,
	react/jsx-closing-bracket-location: 0,
	react/jsx-indent-props: 0,
	react/sort-comp: 0,
	react/jsx-sort-prop-types: 0
 */

import * as React from "react";
import * as ReactDOM from "react-dom";
import classnames from "classnames";

import { CSSTransitionGroup } from 'react-transition-group';

import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { GoogleMap, Marker } from "../Shared";

/*
2017-dec-2 markg: the devtools don't appear to be loading in iOS safari private mode
import DevTools, { configureDevtool } from 'mobx-react-devtools';
configureDevtool({
	updatesEnabled: true,
	logEnabled: true
});*/

import styles from "./AddressForm.module.scss";

const scrollDelayMs = 500;

var isNZ = false;

const postcodeChangedModalElementId = "postcode-change-modal";

type TopLevelAdminBoundary = {
	text: string;
	value: string
};

type CountryBounds = {
	west: number;
	south: number;
	east: number;
	north: number
};

type AddressFormModel = {
	rowFieldsCount: number;

	topLevelAdminBoundaries: TopLevelAdminBoundary[];

	countryBounds: CountryBounds;

	countryCode: string;

	address: string;
	suburb: string;
	postcode: string;
	stateCode: string;
	lat: number;
	lon: number;

	stateLabel: string;

	canChangePostcode: boolean;
	postcodeChangeModalUrl: string;
	showMapToVerifyAddress: boolean;

	contactUsUrl: string;
	supportPhone: string;
};

class ObservableAddressFormStore {

	@observable address = "";
	@observable suburb = "";
	@observable postcode = "";
	@observable stateCode: string = null;

	@observable lat: number = null;
	@observable lon: number = null;

	@observable topLevelAdminBoundaries: TopLevelAdminBoundary[] = null;

	@observable isLatLonCorrect = false;
	@observable isValid = true;

	@observable stateLabel = "";

	@observable doesGoogleNotRecogniseAddress = false;

	countryBounds: CountryBounds = null;
	countryCode: string = null;

	topLevelAdminBoundaryCodesByLowercaseName = null;

	rowFieldsCount: number = null;

	showMapToVerifyAddress = true;

	hasPerformedAtLeastOneAddressLookup = false;

	canChangePostcode = true;
	postcodeChangeModalUrl: string = null;
	lastValidAddress: string = null;

	contactUsUrl: string = null;
	supportPhone: string = null;

	constructor() {
		//mobx.autorun(() => console.log("isValid?" + isValid));
	}

	@action init(vals: AddressFormModel) {

		//2017-mar-3 markg: it is important to spec out
		//all the properties, otherwise Mobx cannot
		//observer their changes
		this.postcodeChangeModalUrl = vals.postcodeChangeModalUrl;

		this.topLevelAdminBoundaries = vals.topLevelAdminBoundaries;

		//2017-aug-9 markg: build up a dictionary of top-level boundaries by state code
		this.topLevelAdminBoundaryCodesByLowercaseName = {};

		for (var i = 0; i < this.topLevelAdminBoundaries.length; i++) {
			var boundary = this.topLevelAdminBoundaries[i];

			this.topLevelAdminBoundaryCodesByLowercaseName[boundary.text.toLowerCase()] = boundary.value;
		}

		this.countryBounds = vals.countryBounds;
		this.countryCode = vals.countryCode;

		this.address = vals.address;
		this.suburb = vals.suburb;
		this.postcode = vals.postcode;
		this.stateCode = vals.stateCode;

		this.lat = vals.lat;
		this.lon = vals.lon;

		this.stateLabel = vals.stateLabel;

		isNZ = vals.countryCode === "NZ";

		this.rowFieldsCount = vals.rowFieldsCount;

		//2018-jul-24 markg: any value except false means we show the map to verify address, even if unspecified
		this.showMapToVerifyAddress = vals.showMapToVerifyAddress !== false;

		this.canChangePostcode = vals.canChangePostcode !== false;
		this.postcodeChangeModalUrl = vals.postcodeChangeModalUrl;
		this.lastValidAddress = this.address;
		this.contactUsUrl = vals.contactUsUrl;
		this.supportPhone = vals.supportPhone;
	}

	@action validate() {

		this.isValid = !this.doesGoogleNotRecogniseAddress && this.isLatLonCorrect && this.lat !== null && this.lon !== null;

		return this.isValid;
	}
}

const observableAddressFormStore = new ObservableAddressFormStore();

if (typeof ReactPage !== "undefined" && typeof ReactPage.addressForm !== "undefined") {
	observableAddressFormStore.init(ReactPage.addressForm);

	//2017-aug-2 markg: called by page validation
	ReactPage.addressForm.validate = function () {

		var isValid = observableAddressFormStore.validate();

		return isValid;
	};
}

var Row = function (props) {

	var styles = null;

	if (props.isVisible === false) {
		styles = {
			display: "none"
		};
	}

	return (
		<div className={classnames("row", props.className)} style={styles}>
			{props.children}
		</div>
	);
};

const MobileBlock6 = function (props) {

	return (
		<div className="small-6 columns mobile-block">
			{props.children}
		</div>
	);
};

const MobileBlock12 = function (props) {

	return (
		<div className="small-12 columns mobile-block">
			{props.children}
		</div>
	);
};

const parseAddressFromGeocodedPlace = function (place) {

	var unitNumber, streetNumber, streetAddress, postcode, stateCode, stateLongName;

	var locality, subLocality;

	// Get each component of the address from the place details
	// and fill the corresponding field on the form.
	for (var i = 0; i < place.address_components.length; i++) {

		for (var j = 0; j < place.address_components[i].types.length; j++) {

			var addressType = place.address_components[i].types[j];

			//console.log("address type: " + addressType + " = ");
			//console.log(place.address_components[i]);

			var hasProcessedAddress = true;

			switch (addressType) {
				case "subpremise":
					unitNumber = place.address_components[i].long_name;
					break;

				case "street_number":
					streetNumber = place.address_components[i].long_name;
					break;

				case "route":
					streetAddress = place.address_components[i].long_name;
					break;

				case "locality":
					locality = place.address_components[i].long_name;
					break;

				case "sublocality_level_1":
					subLocality = place.address_components[i].long_name;
					break;

				case "postal_code":
					postcode = place.address_components[i].long_name;
					break;

				case "administrative_area_level_1":

					stateLongName = place.address_components[i].long_name;

					if (isNZ) {
						var regionName = stateLongName;

						var stateCodeCurrent = observableAddressFormStore.topLevelAdminBoundaryCodesByLowercaseName[regionName.toLowerCase()];

						if (typeof stateCodeCurrent === "undefined" || stateCodeCurrent === null) {
							console.trace("error: could not find admin boundary. name = " + regionName);
						} else {
							stateCode = stateCodeCurrent;
						}
					} else {
						stateCode = place.address_components[i].short_name.toUpperCase();
					}
					break;

				default:
					hasProcessedAddress = false;
					break;
			}

			if (hasProcessedAddress) break;
		}
	}

	var addressLine1 = streetAddress;
	if (streetNumber) addressLine1 = streetNumber + " " + addressLine1;
	if (unitNumber) addressLine1 = unitNumber + "/" + addressLine1;

	var address = addressLine1;

	var suburb;

	if (isNZ && subLocality) {
		suburb = subLocality;
	} else {
		suburb = locality;
	}

	var result = {
		address,
		suburb,
		postcode,
		stateCode,
		stateLongName
	};

	//console.trace(result);

	return result;
};

//2017-jul-28 markg: adapted from here: https://medium.com/@jamsesso/a-simple-react-finite-state-machine-design-pattern-9078e343bdd7
const LocationMapStates = {
	LatLonNeedsConfirmForAddress: 1,
	ReverseGeocoding: 2,
	ReverseGeocodeError: 3,
	ReverseGeocodeNoResults: 4,
	ReverseGeocodeResults: 5,
	ManuallyEditingLocation: 6,
	LatLonDifferentToAddress: 7,
	LatLonCorrect: 8
};

type LocationMapProps = {
	defaultCentre?: google.maps.LatLng | google.maps.LatLngLiteral;
	defaultZoom?: number;
	centre?: /*google.maps.LatLng | */ google.maps.LatLngLiteral;

	address: string;

	onLocationCorrectClick: () => void;
	onAlternativeAddressClick: (address: string) => void;
	onCustomLatLon: (mapCentre: google.maps.LatLngLiteral) => void;
};

type LocationMapState = {

};

@observer
class LocationMap extends React.Component<LocationMapProps, LocationMapState> {

	//2017-jun-2 markg: using mobx for local state: https://medium.com/@mweststrate/3-reasons-why-i-stopped-using-react-setstate-ab73fc67a42e
	@observable geocodeError = null;
	@observable reverseGeocodeResults = null;

	@observable mapState = LocationMapStates.LatLonNeedsConfirmForAddress;

	constructor(props, context) {
		super(props, context);

		this.transition = this.transition.bind(this);

		this.markerDragEnd = this.markerDragEnd.bind(this);
	}

	refMapContainer: HTMLDivElement;

	map: GoogleMap;
	marker: any;
	geocoder: google.maps.Geocoder;

	transition(event, newMapState) {

		//2017-jul-28 markg: stop any button click bubbling up
		if (event) {
			event.preventDefault();
			event.stopPropagation();
		}

		var prevState = this.mapState;

		switch (newMapState) {
			case LocationMapStates.LatLonCorrect:
				if (this.props.onLocationCorrectClick) {
					this.props.onLocationCorrectClick();
				}
				break;

			case LocationMapStates.LatLonDifferentToAddress:
				if (this.props.onCustomLatLon) {
					var position = this.marker.getPosition();

					this.props.onCustomLatLon({ lat: position.lat(), lng: position.lng() });
				}
				break;
		}

		this.mapState = newMapState;
	}

	markerDragEnd() {
		if (!this.geocoder) {
			this.geocoder = new google.maps.Geocoder();
		}

		var position = this.marker.getPosition();
		//this.map.setCenter(position);

		this.transition(null, LocationMapStates.ReverseGeocoding);

		this.geocodeError = null;

		var that = this;

		this.geocoder.geocode({ location: position }, function (results, status) {

			//console.log(results);

			if (status === google.maps.GeocoderStatus.OK) {

				var place = null;

				var streetAddressResults = results.filter(o => o.types[0] === "street_address");

				that.reverseGeocodeResults = streetAddressResults;

				if (streetAddressResults.length > 0) {
					that.transition(null, LocationMapStates.ReverseGeocodeResults);
				} else {
					that.transition(null, LocationMapStates.ReverseGeocodeNoResults);
				}

			} else {

				that.geocodeError = status;

				that.transition(null, LocationMapStates.ReverseGeocodeError);
			}
		});
	}

	handleAlternativeAddressClick(result) {

		this.geocodeError = null;
		this.reverseGeocodeResults = null;

		this.transition(null, LocationMapStates.LatLonNeedsConfirmForAddress);

		if (this.props.onAlternativeAddressClick) {
			this.props.onAlternativeAddressClick(result);
		}
	}

	componentDidMount() {
		this.ensureVisible();
	}

	componentDidUpdate() {
		this.ensureVisible();
	}

	ensureVisible() {
		if (this.mapState === LocationMapStates.LatLonNeedsConfirmForAddress || this.mapState === LocationMapStates.ManuallyEditingLocation) {
			APP.scrollToElement($(this.refMapContainer), scrollDelayMs);
		}
	}

	render() {

		var mapText = null;

		switch (this.mapState) {
			case LocationMapStates.LatLonNeedsConfirmForAddress:
				mapText = <div key="located">
					<p className={styles.instruction}>Does this location match your address?</p>
					<small className={styles.address}>{this.props.address}</small>
					<button className="button" onClick={event => this.transition(event, LocationMapStates.LatLonCorrect)}>Yes</button>
					&nbsp;
					<button className="button secondary" onClick={event => this.transition(event, LocationMapStates.ManuallyEditingLocation)}>Change</button>
				</div>;
				break;

			case LocationMapStates.ReverseGeocoding:
				mapText = <div key="reverseGeoInProgress">
					<p className={styles.instruction}>Looking up addresses...</p>
				</div>;
				break;

			case LocationMapStates.ReverseGeocodeError:
				mapText = <div key="reverseGeoError">
					<p className={styles.instruction}>Error while looking for addresses: {this.geocodeError}</p>
					<button className="button" onClick={event => this.transition(event, LocationMapStates.LatLonNeedsConfirmForAddress)}>Cancel</button>
				</div>;
				break;

			case LocationMapStates.ReverseGeocodeNoResults:
				mapText = <div key="reverseGeoResults">
					<p className={styles.instruction}>No addresses found. Are you sure you wish to use this location?</p>
					<button className="button" onClick={event => this.transition(event, LocationMapStates.LatLonCorrect)}>OK</button>
					&nbsp;
					<button className="button secondary" onClick={event => this.transition(event, LocationMapStates.LatLonNeedsConfirmForAddress)}>Cancel</button>
				</div>;
				break;

			case LocationMapStates.ReverseGeocodeResults:
				var that = this;

				if (this.reverseGeocodeResults.length > 1) {

					var results = this.reverseGeocodeResults.map((o, index) =>
						<li key={o.formatted_address}><a className="underline" onClick={() => that.handleAlternativeAddressClick(o)}><small className={styles.address}>{o.formatted_address}</small></a></li>);

					mapText = <div key="reverseGeoResultsMultiple">
						<p className={styles.instruction}>Your chosen marker location has a different address. Did you want to use one of these addresses instead?</p>
						<ul>{results}</ul>
						<button className="button" onClick={event => this.transition(event, LocationMapStates.LatLonDifferentToAddress)}>No, just previous address</button>
					</div>;

				} else {

					var geocodeResult = this.reverseGeocodeResults[0];

					var parsedAddress = parseAddressFromGeocodedPlace(geocodeResult);

					mapText = <div key="reverseGeoResultsSingle">
						<p className={styles.instruction}>Your chosen marker location has a different address associated with it. Did you want to use this address instead?</p>
						<Row>
							<div className="small-12 medium-6 columns">
								<small className={styles.address}>{parsedAddress.address}, {parsedAddress.suburb} {parsedAddress.postcode}</small>
								<button className="button" onClick={() => that.handleAlternativeAddressClick(geocodeResult)}>Yes, use this new address</button>
							</div>
							<div className="small-12 medium-6 columns">
								<small className={styles.address}>{this.props.address}</small>
								<button className="button" onClick={event => this.transition(event, LocationMapStates.LatLonDifferentToAddress)}>No, use the previous address</button>
							</div>
						</Row>
					</div>;
				}
				/*
				<a className="underline" onClick={() => that.handleAlternativeAddressClick(geocodeResult)}>
				<a className="underline" onClick={event => this.transition(event, LocationMapStates.LatLonDifferentToAddress)}>
				<div className="small-12 medium-4 columns">
								<button className="button secondary" style={{height: "100%"}} onClick={event => this.transition(event, LocationMapStates.ManuallyEditingLocation)}>Change</button>
							</div>*/
				break;

			case LocationMapStates.ManuallyEditingLocation:
				mapText = <div key="editLocation">
					<p className={styles.instruction}>Drag the marker to your actual location</p>
					<button className="button" onClick={event => this.transition(event, LocationMapStates.LatLonNeedsConfirmForAddress)}>Cancel</button>
				</div>;
				break;

			case LocationMapStates.LatLonDifferentToAddress:
				//2017-aug-9 markg: these states are never visible to the user. nothing to display
				mapText = <div key="latLonDifferentToAddress" />;
				break;
		}

		var mapHeight = "300px";

		var isMarkerDraggable = this.mapState === LocationMapStates.ManuallyEditingLocation || this.mapState === LocationMapStates.ReverseGeocodeResults;

		var map = <GoogleMap key="map"
			height={mapHeight}
			defaultCenter={this.props.defaultCentre} defaultZoom={this.props.defaultZoom} center={this.props.centre} ref={r => this.map}
		>
			<Marker position={this.props.centre} draggable={isMarkerDraggable} onDragEnd={this.markerDragEnd} ref={r => this.marker = r} />
		</GoogleMap>;

		return (
			<div className={styles.mapContainer} ref={r => this.refMapContainer = r}>
				{mapText}
				{map}
			</div>
		);
	}

}

type AddressFormProps = {
	store: ObservableAddressFormStore;
};

type AddressFormState = {
	mapCentre: google.maps.LatLngLiteral
};

@observer
class AddressForm extends React.Component<AddressFormProps, AddressFormState> {
	constructor(props, context) {
		super(props, context);

		this.state = {
			mapCentre: {
				lat: 0,
				lng: 0
			}
		};

		this.handleLoad = this.handleLoad.bind(this);
		this.autocompletePlaceChanged = this.autocompletePlaceChanged.bind(this);
		this.fillInAddressFields = this.fillInAddressFields.bind(this);

		this.handleAddressChange = this.handleAddressChange.bind(this);
		this.handleSuburbChange = this.handleSuburbChange.bind(this);
		this.handlePostcodeChange = this.handlePostcodeChange.bind(this);
		this.handleStateChange = this.handleStateChange.bind(this);

		this.handleLocationCorrectClick = this.handleLocationCorrectClick.bind(this);
		this.handleLocationLinkClick = this.handleLocationLinkClick.bind(this);
		this.handleAlternativeAddressClick = this.handleAlternativeAddressClick.bind(this);

		this.handleCustomLatLon = this.handleCustomLatLon.bind(this);
	}

	autoComplete: google.maps.places.Autocomplete;
	refMainDiv: HTMLDivElement;
	addressEl: HTMLInputElement;

	place: google.maps.places.PlaceResult;

	componentDidMount() {
		window.addEventListener("load", this.handleLoad);

		this.ensureVisible();
	}

	componentDidUpdate() {
		this.ensureVisible();
	}

	ensureVisible() {
		var store = this.props.store;

		if (store.showMapToVerifyAddress && store.hasPerformedAtLeastOneAddressLookup && store.isLatLonCorrect && store.lat !== null) {
			APP.scrollToElement($(this.refMainDiv), scrollDelayMs);
		}
	}

	//componentDidUpdate(prevProps, prevState) {

	//	if (this.state.showMap && !prevState.showMap) {
	//		//2017-may-30 markg: must trigger a google maps
	//		//resize, now the hidden div is displayed
	//		// see: https://stackoverflow.com/a/6879644
	//		google.maps.event.trigger(this.map, "resize");
	//	}
	//}

	handleLoad() {

		this.autoComplete = new google.maps.places.Autocomplete(this.addressEl, {
			types: ["address"],
			bounds: this.props.store.countryBounds,
			strictBounds: true
		});

		this.autoComplete.addListener('place_changed', this.autocompletePlaceChanged);
	}

	autocompletePlaceChanged() {

		// Get the place details from the autocomplete object.
		const place = this.autoComplete.getPlace();

		//console.log("place found:");
		//console.log(place);

		const store = this.props.store;

		store.hasPerformedAtLeastOneAddressLookup = true;

		const isInvalidPlace = typeof place.place_id === "undefined";

		store.doesGoogleNotRecogniseAddress = isInvalidPlace;

		if (isInvalidPlace) {
			//2018-dec-7 markg: we had an instance where 45 Huntingfield Drive, Hoppers Crossing
			//would show up in the autocomplete list. however, when selected, the autocomplete
			//place object simply only has the "name" property set.
			///we need to handle this oddity gracefully, by displaying a message to the user.

			store.isLatLonCorrect = false;

		} else {

			let canUseNewAddress = true;

			if (!store.canChangePostcode) {
				const currentPostcode = store.postcode;

				const parsedAddress = parseAddressFromGeocodedPlace(place)

				const newPostcode = parsedAddress.postcode;

				if (currentPostcode !== newPostcode) {
					canUseNewAddress = false;
					this.addressEl.value = store.lastValidAddress;

					($("#" + postcodeChangedModalElementId) as any).foundation("reveal", "open", { url: store.postcodeChangeModalUrl });
				}
			}

			if (canUseNewAddress) {
				this.fillInAddressFields(place);
			}
		}
	}

	fillInAddressFields(place: google.maps.places.PlaceResult) {

		this.place = place;

		const store = this.props.store;

		const geom = place.geometry;

		store.lat = geom.location.lat();
		store.lon = geom.location.lng();

		if (store.showMapToVerifyAddress === true) {
			store.isLatLonCorrect = false;
		} else {
			store.isLatLonCorrect = true;
			store.isValid = true;
		}

		this.setState({
			mapCentre: { lat: store.lat, lng: store.lon }
		});

		var parsedAddress = parseAddressFromGeocodedPlace(place);

		store.address = store.lastValidAddress = parsedAddress.address;
		store.suburb = parsedAddress.suburb;
		store.postcode = parsedAddress.postcode;
		store.stateCode = parsedAddress.stateCode;
	}

	handleAddressChange(event) {
		this.props.store.address = event.target.value;
	}

	handleSuburbChange(event) {
		this.props.store.suburb = event.target.value;
	}

	handlePostcodeChange(event) {
		this.props.store.postcode = event.target.value;
	}

	handleStateChange(event) {
		this.props.store.stateCode = event.target.value;
	}

	handleLocationCorrectClick() {
		var store = this.props.store;

		store.isValid = true;
		store.isLatLonCorrect = true;
	}

	handleLocationLinkClick() {
		var store = this.props.store;

		store.isLatLonCorrect = false;
	}

	handleAlternativeAddressClick(address) {
		this.fillInAddressFields(address);
	}

	handleCustomLatLon(mapCentre) {

		var store = this.props.store;

		store.lat = mapCentre.lat;
		store.lon = mapCentre.lng;

		store.isValid = true;
		store.isLatLonCorrect = true;

		this.setState({
			mapCentre: { lat: store.lat, lng: store.lon }
		});
	}

	render() {
		var store = this.props.store;

		var adminBoundaryOptions = [];

		for (var i = 0; i < store.topLevelAdminBoundaries.length; i++) {
			var boundary = store.topLevelAdminBoundaries[i];

			var option = <option key={boundary.value} value={boundary.value}>{boundary.text}</option>;

			adminBoundaryOptions.push(option);
		}

		var latLonCorrectRow = null;

		if (store.hasPerformedAtLeastOneAddressLookup && store.isLatLonCorrect) {

			if (store.showMapToVerifyAddress) {
				latLonCorrectRow =
					<Row key="locationCorrect">
						<MobileBlock6>
							<p className={styles.instruction}>Thanks, we have saved your <a className="underline" onClick={this.handleLocationLinkClick}>location</a></p>
						</MobileBlock6>
					</Row>;
			}

		} else if (store.doesGoogleNotRecogniseAddress) {
			latLonCorrectRow = <Row key="googleDoesNotRecognise">
				<MobileBlock6>
					<p className={styles.alert}>Sorry, Google does not recognise this address. We cannot locate it. If this address
					is correct,
						please <a href={store.contactUsUrl} target="_blank">send us an email</a>, use the live chat button below
						or call us on <a href={"tel:" + store.supportPhone}>{store.supportPhone}</a>.</p>

				</MobileBlock6>
			</Row>;
		}

		const rowFieldsCount = store.rowFieldsCount;

		let formFieldsArray = [];

		if (rowFieldsCount === 2) {
			formFieldsArray.push(<Row key="address">
				<MobileBlock6>
					<label>
						Address <em>*</em>
						<input type="text" ref={r => this.addressEl = r} name="address" maxLength={200} data-rule-required="true" placeholder="Enter a full address" value={store.address} onChange={this.handleAddressChange} autoComplete="off" />
					</label>
				</MobileBlock6>
				<MobileBlock6>
					<label>
						Town/Suburb <em>*</em>
						<input type="text" name="suburb" maxLength={200} alt="Suburb" value={store.suburb} data-rule-required="true" onChange={this.handleSuburbChange} />
					</label>
				</MobileBlock6>
			</Row>);

			formFieldsArray.push(<Row key="postcode">
				<MobileBlock6>
					<label htmlFor="postcode">
						Postcode <em>*</em>
						<input type="text" name="postcode" maxLength={4} data-rule-required="true" value={store.postcode} onChange={this.handlePostcodeChange} className={store.canChangePostcode ? "" : "disabled"} data-reveal-id={store.canChangePostcode ? "" : postcodeChangedModalElementId} data-reveal-ajax={store.canChangePostcode ? "" : store.postcodeChangeModalUrl} />
					</label>
				</MobileBlock6>
				<MobileBlock6>
					<label>
						{store.stateLabel} <em>*</em>
						<select name="stateCode" data-rule-required="true" value={store.stateCode === null ? "" : store.stateCode} onChange={this.handleStateChange}>
							<option key="<blank>" value="">--</option>
							{adminBoundaryOptions}
						</select>
					</label>
				</MobileBlock6>
			</Row>);

		} else if (rowFieldsCount === 3) {

			formFieldsArray.push(<Row key="address">
				<MobileBlock12>
					<label>
						Address <em>*</em>
						<input type="text" ref={r => this.addressEl = r} name="address" maxLength={200} data-rule-required="true" placeholder="Enter a full address" value={store.address} onChange={this.handleAddressChange} autoComplete="off" />
					</label>
				</MobileBlock12>
			</Row>);

			formFieldsArray.push(<Row key="suburb">
				<MobileBlock6>
					<label>
						Town/Suburb <em>*</em>
						<input type="text" name="suburb" maxLength={200} alt="Suburb" value={store.suburb} data-rule-required="true" />
					</label>
				</MobileBlock6>
				<MobileBlock6>
					<label htmlFor="postcode">
						Postcode <em>*</em>
						<input type="text" name="postcode" maxLength={4} data-rule-required="true" value={store.postcode} onChange={this.handlePostcodeChange} className={store.canChangePostcode ? "" : "disabled"} data-reveal-id={store.canChangePostcode ? "" : postcodeChangedModalElementId} data-reveal-ajax={store.canChangePostcode ? "" : store.postcodeChangeModalUrl} />
					</label>
				</MobileBlock6>
			</Row>);

			formFieldsArray.push(<Row key="state">
				<MobileBlock12>
					<label>
						{store.stateLabel} <em>*</em>
						<select name="stateCode" data-rule-required="true" value={store.stateCode === null ? "" : store.stateCode} onChange={this.handleStateChange}>
							<option key="<blank>" value="">--</option>
							{adminBoundaryOptions}
						</select>
					</label>
				</MobileBlock12>
			</Row>);

		} else {
			throw Error(`unknown field rows value. row fields count = ${rowFieldsCount}`);
		}

		const showMap = store.showMapToVerifyAddress && store.hasPerformedAtLeastOneAddressLookup && !store.doesGoogleNotRecogniseAddress && store.lat !== null && store.isLatLonCorrect !== true;

		let mapRow = null;

		if (showMap) {

			mapRow =
				<Row key="map">
					<div className={classnames("small-12 medium-6 columns end", store.isValid ? null : styles.invalid)}>
						<LocationMap defaultCentre={{ lat: store.lat, lng: store.lon }} defaultZoom={18} centre={this.state.mapCentre}
							address={store.address + ", " + store.suburb + " " + store.postcode}
							onLocationCorrectClick={this.handleLocationCorrectClick} onAlternativeAddressClick={this.handleAlternativeAddressClick}
							onCustomLatLon={this.handleCustomLatLon}
						/>
					</div>
				</Row>;
		}

		return (
			<div ref={r => this.refMainDiv = r}>
				{ store.lat !== null && store.lon !== null
					? <div>
						<input type="hidden" name="lat" value={store.lat} />
						<input type="hidden" name="lon" value={store.lon} />
					</div>
					: null
				}
				{formFieldsArray}
				{/*<Row>
					<MobileBlock6>
						<pre>{JSON.stringify(styles, null, 2)}</pre>
					</MobileBlock6>
				</Row>*/}

				<CSSTransitionGroup
					transitionName={{
						enter: styles["map-panel-enter"],
						enterActive: styles["map-panel-enter-active"],
						leave: styles["map-panel-exit"],
						leaveActive: styles["map-panel-exit-active"],
						//appear: styles["map-panel-appear"],
						//appearActive: styles["map-panel-appear-active"],
					}}
					transitionEnterTimeout={225}
					transitionLeaveTimeout={200}>

					{latLonCorrectRow}
					{mapRow}
				</CSSTransitionGroup>
			</div>
		);
	}
}

ReactDOM.render(<AddressForm store={observableAddressFormStore} />, document.getElementById("addressForm"));